/* eslint-disable prefer-rest-params */

// WARNING: This file replace problematic tailwind-merge module. That means that usage of tailwind-merge can be problematic
// Stub file to replace problematic tailwind-merge ES modules

function twMerge() {
	const args = Array.from(arguments);
	return args.filter(Boolean).join(' ');
}

function createClassUtils() {
	return {
		merge: twMerge,
		validators: [],
		classGroups: {},
	};
}

module.exports = twMerge;
module.exports.default = twMerge;
module.exports.twMerge = twMerge;
module.exports.createClassUtils = createClassUtils;
